export const FORM_TYPE = {
  DOCENTE: 'Docente',
  NO_DOCENTE: 'No docente',
};

export const FORM_TYPE_OPTIONS = Object.keys(FORM_TYPE).map((key) => FORM_TYPE[key]);

export const DOCUMENT_TYPE = {
  FISABS: 'FISABS',
  SCH: 'SCH',
  GRC: 'GRC',
  SCF: 'SCF',
  FCA: 'FCA',
};

export const YES_OR_NO_OPTIONS = [
  'Sí',
  'No',
];

export const WEEK_DAY_OPTIONS = [
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
  'Domingo',
];
